export default "__VITE_ASSET__7aa24139__"